import React, { useEffect } from 'react';
import Icon from '../../../components/AppIcon';

const SuccessMessage = ({ message, isVisible, onHide }) => {
  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(() => {
        onHide();
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [isVisible, onHide]);

  if (!isVisible) return null;

  return (
    <div className="fixed top-20 right-6 z-50 animate-slide-down">
      <div className="bg-success text-success-foreground px-4 py-3 rounded-lg shadow-elevated flex items-center space-x-2 min-w-[300px]">
        <Icon name="CheckCircle" size={20} />
        <span className="text-sm font-medium">{message}</span>
        <button
          onClick={onHide}
          className="ml-auto text-success-foreground hover:text-success-foreground/80 transition-colors"
        >
          <Icon name="X" size={16} />
        </button>
      </div>
    </div>
  );
};

export default SuccessMessage;